enum ColorsEnum {
  Black = 'black',
  Blue = 'blue',
  Yellow = 'yellow',
  Green = 'green',
  Pink = 'pink',
}

export default ColorsEnum
